import { WizardConfig, WizardErrors } from '../../types/wizard'

interface Props {
  config: WizardConfig
  updateConfig: (updates: Partial<WizardConfig>) => void
  errors: WizardErrors
}

export default function Step2Calendly({ config, updateConfig, errors }: Props) {
  // Extract username from full URL if present
  const getCalendlyUsername = (url: string) => {
    if (!url) return ''
    // Remove https://calendly.com/ prefix if present
    return url.replace(/^https?:\/\/(www\.)?calendly\.com\//, '')
  }

  const handleUsernameChange = (username: string) => {
    // Build full URL from username
    const fullUrl = username ? `https://calendly.com/${username}` : ''
    updateConfig({ calendlyUrl: fullUrl })
  }

  const username = getCalendlyUsername(config.calendlyUrl)

  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-2">Connect Your Calendly</h2>
      <p className="text-gray-600 mb-8">
        Your chatbot will automatically book appointments to your Calendly calendar.
      </p>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Calendly Username *
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <span className="text-gray-500">https://calendly.com/</span>
            </div>
            <input
              type="text"
              value={username}
              onChange={(e) => handleUsernameChange(e.target.value)}
              placeholder="yourname"
              className={`w-full pl-[175px] pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent ${
                errors.calendlyUrl ? 'border-red-500' : 'border-gray-300'
              }`}
            />
          </div>
          {errors.calendlyUrl && (
            <p className="mt-1 text-sm text-red-600">{errors.calendlyUrl}</p>
          )}
          <p className="mt-1 text-sm text-gray-500">
            Just enter your Calendly username (e.g., "john-doe")
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="font-semibold text-blue-900 mb-2">Don't have a Calendly account?</h3>
          <p className="text-sm text-blue-800 mb-3">
            Calendly makes it easy for prospects to book time with you. Sign up for free:
          </p>
          <a
            href="https://calendly.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-blue-600 hover:text-blue-700 font-semibold underline"
          >
            Create your free Calendly account →
          </a>
        </div>
      </div>
    </div>
  )
}
